import { isCapacitor } from '@src/utils/platformUtil.js'

export async function initMobileExperience() {
  if (!isCapacitor()) return

  const { Keyboard } = await import('@capacitor/keyboard')
  try {
    await Keyboard.setResizeMode({ mode: 'body' })
  } catch (error) {
    console.warn('[MobileUX] Failed to set keyboard resize mode', error) // eslint-disable-line no-console
  }

  Keyboard.addListener('keyboardWillShow', ({ keyboardHeight }) => {
    document.documentElement.style.setProperty('--keyboard-offset', `${keyboardHeight}px`)
    document.body.classList.add('keyboard-visible')
  })

  Keyboard.addListener('keyboardWillHide', () => {
    document.documentElement.style.setProperty('--keyboard-offset', '0px')
    document.body.classList.remove('keyboard-visible')
  })
}
